import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MarkBarHelpComponent } from '../modals/markbar-help/markbar-help.component';
import { SDGHelpComponent } from './sdg-help/sdg-help.component';
import {OfferSentenceHelpComponent} from './offer-sentence-help/offer-sentence-help.component'

@Injectable({
  providedIn: 'root'
})
export class ModalsService {
  constructor(  public matDialog: MatDialog) { }
  
  openMarkEntryHelp() {
    const modalConfig = new MatDialogConfig();    
    const modalDialog = this.matDialog.open(MarkBarHelpComponent, modalConfig);
  }
  openSDGHelp(){
    const modalConfig = new MatDialogConfig();    
    const modalDialog = this.matDialog.open(SDGHelpComponent, modalConfig);
  }

  openOfferSentenceHelp(){
    const modalConfig = new MatDialogConfig();    
    const modalDialog = this.matDialog.open(OfferSentenceHelpComponent, modalConfig);
  }
 
}
